var _ = require("../../../uam/module.js")(module.exports, {
  namespace: "ua.preview.tags",
  title: "Control Preview: Tags",
  description: "Read-only preview renderer for list/tag values.",
  fields: {
    "value": { title: "Value", type: "*", description: "Array or single value." }
  }
});

var helper = require("./helpers/control.preview.js");

exports.render = async function(options) {
  var value = options.value;
  var list = [];

  if (Array.isArray(value)) {
    list = value.map(function(item) {
      return helper.valueToText(item).trim();
    }).filter(function(item) {
      return item.length > 0;
    });
  } else {
    var single = helper.valueToText(value).trim();
    if (single) {
      list = single.split(",").map(function(item) {
        return item.trim();
      }).filter(function(item) {
        return item.length > 0;
      });
    }
  }

  if (list.length === 0) {
    return helper.renderDoc({
      n: "span",
      c: "ua-control-preview-empty",
      i: "Not provided"
    });
  }

  return helper.renderDoc({
    n: "div",
    c: "ua-control-preview-tags",
    i: list.map(function(item) {
      return {
        n: "span",
        c: "ua-control-preview-tag",
        i: item
      };
    })
  });
};
